// import enum
export const state = {
  filter: {
    keyword: "",
    contact_email: "",
    status: [],
    isFilter: false,
  },
};
export const mutations = {
  addFilterClientApps: (state, data) => {
    state.filter = data;
    state.filter.isFilter = true;
  },
  clearFilterClientApps: (state) => {
    state.filter = {
      keyword: "",
      contact_email: "",
      status: [],
    };
  },
};
export const getters = {
  GET_FILTER_CLIENT_APPS: (state) => {
    return state.filter;
  },
};
export const actions = {
  ADD_FILTER_CLIENT_APPS: ({ commit }, data) => {
    commit("addFilterClientApps", data);
  },
  CLEAR_FILTER_CLIENT_APPS: ({ commit }) => {
    commit("clearFilterClientApps");
  },
};
